import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";

import { Influencer, InfluencerContact } from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";

export function useUpdateContact() {
  const {
    mutate: updateContact,
    isLoading: isUpdating,
    isSuccess: isUpdated,
    variables,
  } = useMutation<
    { influencerId: string; contact: Partial<InfluencerContact> },
    BackednResponse<Influencer> | void
  >({
    mutationFn: async ({ influencerId, contact }) => {
      return await InfluencerService.updateContact(influencerId, contact).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: INFLUENCER_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { influencerId }) => {
      c.invalidateQueries({ queryKey: INFLUENCER_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...INFLUENCER_LIST_QUERY_KEY, influencerId],
      });
    },
  });

  return {
    updateContact,
    isUpdating,
    isUpdated,
    variables,
  };
}
